// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1199":"a019081c","2438":"896f1175"}[chunkId] + ".chunk.css";
};